// frontend/src/components/Sidebar.js

import React, { useState, useEffect } from 'react';
import { FaAmbulance } from 'react-icons/fa';

const Sidebar = ({ 
  locations, 
  selectedCategory, 
  setSelectedCategory,
  selectedTownship,
  setSelectedTownship,
  waterLevel,
  setWaterLevel,
  setFilteredLocations,
  isLoading,
  mapClickedLocation,
  onShowDashboard,
  onGetUserLocation,
  onBasemapChange,
  showAIChat,
  setShowAIChat,
  onShowNotifications,
  showNotifications,
  onEmergencyClick,
  basemap,
  setBasemap,
  isGPSOn = false,
  onToggleAdmin = null,
  onToggleGPS = null
}) => {
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showLogin, setShowLogin] = useState(false);
  const [showMapSelector, setShowMapSelector] = useState(false);
  const [selectedMap, setSelectedMap] = useState('osm');
  
  // Report Form
  const [showReportForm, setShowReportForm] = useState(false);
  const [reportData, setReportData] = useState({
    title: '',
    description: '',
    location_name: '',
    lat: '',
    lng: '',
    severity: 'medium',
    reporter_name: '',
    reporter_phone: '',
    photos: []
  });

// Voice Report Form
const [showVoiceForm, setShowVoiceForm] = useState(false);
const [voiceData, setVoiceData] = useState({
    report_type: 'road',
    description: '',
    location_name: '',
    lat: '',
    lng: '',
    photo: null,
    phone: '',           // ✅ ထည့်ပါ
    email: '',           // ✅ ထည့်ပါ
    reporter_name: ''    // ✅ ထည့်ပါ
});
  // Register New Business
  const [showRegisterForm, setShowRegisterForm] = useState(false);
  const [regName, setRegName] = useState('');
  const [regPhone, setRegPhone] = useState('');
  const [regTown, setRegTown] = useState('myitkyina');
  const [regCat, setRegCat] = useState('');
  const [regSubCat, setRegSubCat] = useState('');

// Categories and Subcategories (same as before - keep your existing data)
const categories = [
  { id: 'all', name_mm: 'အားလုံး', icon: '📍' },
  { id: 'restaurant', name_mm: 'စားသောက်ဆိုင်', icon: '🍽️' },
  { id: 'market', name_mm: 'ဈေး/ကုန်စုံ', icon: '🛒' },
  { id: 'school', name_mm: 'ပညာရေး', icon: '🏫' },
  { id: 'religion', name_mm: 'ဘာသာရေး', icon: '🕍' },
  { id: 'hotel', name_mm: 'ဟိုတယ်/တည်းခိုခန်း', icon: '🏨' },
  { id: 'healthcare', name_mm: 'ကျန်းမာရေး', icon: '🏥' },
  { id: 'finance', name_mm: 'ဘဏ်/ငွေကြေး', icon: '🏦' },
  { id: 'beauty', name_mm: 'အလှအပ', icon: '💄' },
  { id: 'hardware', name_mm: 'ဆောက်လုပ်ရေး/ပစ္စည်း', icon: '🔨' },
  { id: 'it', name_mm: 'ကွန်ပျူတာ/နည်းပညာ', icon: '💻' },
  { id: 'government', name_mm: 'အစိုးရရုံး', icon: '🏛️' },
  { id: 'workshop', name_mm: 'ပြုပြင်ရေးဆိုင်', icon: '🔧' },
  { id: 'transport', name_mm: 'သယ်ယူပို့ဆောင်ရေး', icon: '🚌' },
  { id: 'phone', name_mm: 'ဖုန်းဆိုင်', icon: '📱' },
  { id: 'fashion', name_mm: 'အဝတ်အထည်/ဖက်ရှင်', icon: '👗' },
  { id: 'tourism', name_mm: 'ခရီးသွားလာရေး', icon: '📍' },
  { id: 'sports', name_mm: 'အားကစား', icon: '⚽' },
  { id: 'fuel', name_mm: 'ဓာတ်ဆီ/မော်တော်ဆီဆိုင်', icon: '⛽' },
  { id: 'entertainment', name_mm: 'ဖျော်ဖြေရေး', icon: '🎭' }
];

const subcategories = {
  restaurant: [
    { name: 'ကော်ဖီဆိုင်', icon: '☕', query: 'ကော်ဖီ' },
    { name: 'ခေါက်ဆွဲဆိုင်', icon: '🍜', query: 'ခေါက်ဆွဲ' },
    { name: 'စားသောက်ဆိုင်', icon: '🍽️', query: 'စားသောက်' },
    { name: 'ထမင်းဆိုင်', icon: '🍚', query: 'ထမင်း' },
    { name: 'ပင်လယ်စာဆိုင်', icon: '🦐', query: 'ပင်လယ်စာ' },
    { name: 'ဘီယာဆိုင်', icon: '🍺', query: 'ဘီယာ' },
    { name: 'အရက်ဆိုင်', icon: '🥃', query: 'အရက်' },
    { name: 'မုန့်ဆိုင်', icon: '🥐', query: 'မုန့်' },
    { name: 'မုန့်ဟင်းခါးဆိုင်', icon: '🥟', query: 'မုန့်ဟင်းခါး' },
    { name: 'လက်ဖက်ရည်ဆိုင်', icon: '🫖', query: 'လက်ဖက်ရည်' },
    { name: 'အကင်ဆိုင်', icon: '🔥', query: 'အကင်' },
    { name: 'အအေးဆိုင်', icon: '🧃', query: 'အအေး' }
  ],
  market: [
    { name: 'ကုန်စုံဆိုင်', icon: '🏪', query: 'ကုန်စုံ' },
    { name: 'စူပါမားကတ်', icon: '🛍️', query: 'စူပါမားကတ်' },
    { name: 'မီနီမားကတ်', icon: '🏬', query: 'မီနီမာ့တ်' },
    { name: 'အထွေထွေကုန်စုံဆိုင်', icon: '🏪', query: 'အထွေထွေကုန်စုံ' },
    { name: 'အသားဆိုင်', icon: '🥩', query: 'အသား' },
    { name: 'ကုန်ခြောက်ဆိုင်', icon: '📦', query: 'ကုန်ခြောက်' },
    { name: 'ဆန်ဆိုင်', icon: '🌾', query: 'ဆန်' },
    { name: 'ငါးဆိုင်', icon: '🐟', query: 'ငါး' }
  ],
  school: [
    { name: 'မူကြိုကျောင်း', icon: '🧸', query: 'မူကြို' },
    { name: 'မူလတန်းကျောင်း', icon: '🏫', query: 'မူလတန်း' },
    { name: 'အလယ်တန်းကျောင်း', icon: '📚', query: 'အလယ်တန်း' },
    { name: 'အထက်တန်းကျောင်း', icon: '🎓', query: 'အထက်တန်း' },
    { name: 'တက္ကသိုလ်', icon: '🏛️', query: 'တက္ကသိုလ်' },
    { name: 'ကိုယ်ပိုင်ကျောင်း', icon: '🏫', query: 'ကိုယ်ပိုင်ကျောင်း' },
    { name: 'ကျူရှင်ကျောင်း', icon: '📖', query: 'ကျူရှင်' },
    { name: 'ဘာသာစကားသင်တန်း', icon: '🗣️', query: 'ဘာသာစကား' },
    { name: 'အချက်အပြုတ်သင်တန်း', icon: '🍳', query: 'အချက်အပြုတ်' },
    { name: 'IT သင်တန်း', icon: '💻', query: 'IT' },
    { name: 'ဖက်ရှင်သင်တန်း', icon: '👗', query: 'ဖက်ရှင်' },
    { name: 'အွန်လိုင်းသင်တန်း', icon: '🌐', query: 'အွန်လိုင်း' }
  ],
  religion: [
    { name: 'သာသနာရေးရုံး', icon: '📿', query: 'သာသနာ' },
    { name: 'ဗုဒ္ဓဘာသာ', icon: '☸️', query: 'ဗုဒ္ဓ' },
    { name: 'ဘုရား/စေတီ', icon: '🛕', query: 'ဘုရား' },
    { name: 'ဘုန်းကြီးကျောင်း', icon: '🛕', query: 'ဘုန်းကြီးကျောင်း' },
    { name: 'ရွှေရင်ကျော်ဂိုဏ်း', icon: '🕍', query: 'ရွှေရင်ကျော်' },
    { name: 'ဗေဒင်/လက္ခဏာ', icon: '🔮', query: 'ဗေဒင်' },
    { name: 'နတ်ကတော်', icon: '🕯️', query: 'နတ်ကတော်' },
    { name: 'ဟိန္ဒူ', icon: '🕉️', query: 'ဟိန္ဒူ' },
    { name: 'ဆစ်', icon: '🪯', query: 'ဆစ်' },
    { name: 'အစ္စလာမ်', icon: '🕌', query: 'အစ္စလာမ်' },
    { name: 'ခရစ်ယာန်', icon: '⛪', query: 'ခရစ်ယာန်' },
    { name: 'ကက်သလစ်', icon: '⛪', query: 'ကက်သလစ်' },
    { name: 'နှစ်ခြင်း', icon: '⛪', query: 'နှစ်ခြင်း' },
    { name: 'အေဂျီ', icon: '⛪', query: 'အေဂျီ' },
    { name: 'ဘုရားကျောင်း', icon: '⛪', query: 'ဘုရားကျောင်း' },
    { name: 'နတ်ဂျော့', icon: '🕯️', query: 'နတ်ဂျော့' },
    { name: 'ဆုတောင်းတောင်', icon: '⛰️', query: 'ဆုတောင်း' },
    { name: 'အေဝင်ဂေလီ', icon: '⛪', query: 'အေဝင်ဂေလီ' },
    { name: 'ကရင်နှစ်ခြင်း', icon: '⛪', query: 'ကရင်နှစ်ခြင်း' },
    { name: 'ဓမ္မကျောင်း', icon: '📿', query: 'ဓမ္မ' },
    { name: 'ဗလီ', icon: '🕌', query: 'ဗလီ' }
  ],
  hotel: [
    { name: 'ဟိုတယ်', icon: '🏨', query: 'ဟိုတယ်' },
    { name: 'မိုတယ်', icon: '🏩', query: 'မိုတယ်' },
    { name: 'ရီဇော့', icon: '🌴', query: 'ရီဇော့' },
    { name: 'တည်းခိုခန်း', icon: '🏠', query: 'တည်းခိုခန်း' },
    { name: 'အင်း', icon: '🏡', query: 'အင်း' },
    { name: 'ဧည့်ရိပ်သာ', icon: '🏕️', query: 'ဧည့်ရိပ်သာ' },
    { name: 'ဂတ်စ်ဟောက်', icon: '🏠', query: 'ဂတ်စ်ဟောက်' },
    { name: 'ဟော်စတယ်', icon: '🛏️', query: 'ဟော်စတယ်' }
  ],
  healthcare: [
    { name: 'ဆေးရုံ', icon: '🏥', query: 'ဆေးရုံ' },
    { name: 'ဆေးခန်း', icon: '🩺', query: 'ဆေးခန်း' },
    { name: 'ဆေးဆိုင်', icon: '💊', query: 'ဆေးဆိုင်' },
    { name: 'ကလေးဆေးခန်း', icon: '👶', query: 'ကလေးဆေး' },
    { name: 'မျက်စိဆေးခန်း', icon: '👁️', query: 'မျက်စိ' },
    { name: 'သွားဆေးခန်း', icon: '🦷', query: 'သွားဆေး' },
    { name: 'တိုင်းရင်းဆေးခန်း', icon: '🌿', query: 'တိုင်းရင်းဆေး' },
    { name: 'ဓာတ်ခွဲခန်း', icon: '🧪', query: 'ဓာတ်ခွဲ' },
    { name: 'ကျန်းမာရေးသင်တန်း', icon: '📚', query: 'ကျန်းမာရေးသင်တန်း' }
  ],
  finance: [
    { name: 'ဘဏ်', icon: '🏦', query: 'ဘဏ်' },
    { name: 'အေတီအမ်', icon: '🏧', query: 'အေတီအမ်' },
    { name: 'ငွေလွှဲကုမ္ပဏီ', icon: '💰', query: 'ငွေလွှဲ' },
    { name: 'ရွှေဆိုင်', icon: '💍', query: 'ရွှေ' },
    { name: 'အပေါင်ဆိုင်', icon: '📄', query: 'အပေါင်' },
    { name: 'အာမခံ', icon: '🛡️', query: 'အာမခံ' },
    { name: 'မိုဘိုင်းငွေပေးချေမှု', icon: '📱', query: 'မိုဘိုင်းငွေ' },
    { name: 'မိုက်ခရိုဘဏ္ဍာရေး', icon: '💵', query: 'မိုက်ခရိုဘဏ္ဍာ' }
  ],
  beauty: [
    { name: 'အလှပြင်ဆိုင်', icon: '💄', query: 'အလှပြင်' },
    { name: 'ဆံပင်အလှပြင်ဆိုင်', icon: '✂️', query: 'ဆံပင်' },
    { name: 'အလှကုန်ဆိုင်', icon: '💋', query: 'အလှကုန်' },
    { name: 'လက်သည်းအလှပြင်ဆိုင်', icon: '💅', query: 'လက်သည်း' },
    { name: 'စပါ', icon: '🧖', query: 'စပါ' },
    { name: 'ဘာဘာဆိုင်', icon: '💈', query: 'ဘာဘာ' }
  ],
  hardware: [
    { name: 'ဟာ့ဒ်ဝဲဆိုင်', icon: '🔨', query: 'ဟာ့ဒ်ဝဲ' },
    { name: 'အလူမီနီယံဆိုင်', icon: '🔩', query: 'အလူမီနီယံ' },
    { name: 'လျှပ်စစ်ပစ္စည်းဆိုင်', icon: '⚡', query: 'လျှပ်စစ်' },
    { name: 'ရေပိုက်ပစ္စည်းဆိုင်', icon: '🚰', query: 'ရေပိုက်' },
    { name: 'ဆောက်လုပ်ရေးကုမ္ပဏီ', icon: '🏗️', query: 'ဆောက်လုပ်ရေး' },
    { name: 'လက်သမားဆိုင်', icon: '🪚', query: 'လက်သမား' },
    { name: 'ပန်းရံဆိုင်', icon: '🧱', query: 'ပန်းရံ' },
    { name: 'လေအေးပေးစက်ဝန်ဆောင်မှု', icon: '❄️', query: 'လေအေးပေးစက်' },
    { name: 'ကုမ္ပဏီ', icon: '🏢', query: 'ကုမ္ပဏီ' },
    { name: 'မီးစက်ပြင်', icon: '🔧', query: 'မီးစက်' }
  ],
  it: [
    { name: 'ကွန်ပျူတာဆိုင်', icon: '💻', query: 'ကွန်ပျူတာ' },
    { name: 'ကွန်ပျူတာပြုပြင်ရေးဆိုင်', icon: '🛠️', query: 'ကွန်ပျူတာပြုပြင်' },
    { name: 'ကွန်ယက်ဝန်ဆောင်မှု', icon: '🌐', query: 'ကွန်ယက်' },
    { name: 'အင်တာနက်ကော်ဖီဆိုင်', icon: '🌍', query: 'အင်တာနက်' },
    { name: 'စီစီတီဗွီဆိုင်', icon: '📹', query: 'စီစီတီဗွီ' },
    { name: 'ပရင်တာဝန်ဆောင်မှု', icon: '🖨️', query: 'ပရင်တာ' },
    { name: 'ဆော့ဖ်ဝဲလ်ကုမ္ပဏီ', icon: '💾', query: 'ဆော့ဖ်ဝဲ' }
  ],
  government: [
    { name: 'အစိုးရရုံး', icon: '🏛️', query: 'အစိုးရရုံး' },
    { name: 'မြို့နယ်ရုံး', icon: '🏢', query: 'မြို့နယ်ရုံး' },
    { name: 'ရဲစခန်း', icon: '👮', query: 'ရဲစခန်း' },
    { name: 'မီးသတ်စခန်း', icon: '🚒', query: 'မီးသတ်' },
    { name: 'တရားရုံး', icon: '⚖️', query: 'တရားရုံး' },
    { name: 'ပြည်သူ့ဝန်ဆောင်မှုရုံး', icon: '📑', query: 'ပြည်သူ့ဝန်ဆောင်မှု' }
  ],
  workshop: [
    { name: 'ကားဝပ်ရှော့', icon: '🚗', query: 'ကားဝပ်ရှော့' },
    { name: 'ကားပြုပြင်ရေးဆိုင်', icon: '🚗', query: 'ကားပြုပြင်' },
    { name: 'ကားဘော်ဒီဆိုင်', icon: '🚘', query: 'ကားဘော်ဒီ' },
    { name: 'ဆိုင်ကယ်ပြုပြင်ရေးဆိုင်', icon: '🏍️', query: 'ဆိုင်ကယ်ပြုပြင်' },
    { name: 'ဘက်ထရီဆိုင်', icon: '🔋', query: 'ဘက်ထရီ' },
    { name: 'တာယာဆိုင်', icon: '🛞', query: 'တာယာ' },
    { name: 'လေအေးပေးစက်ဝန်ဆောင်မှု', icon: '❄️', query: 'လေအေးပေးစက်' },
    { name: 'ကားရေဆေးဆိုင်', icon: '🧽', query: 'ကားရေဆေး' },
    { name: 'ကားအလှပြင်ဆိုင်', icon: '✨', query: 'ကားအလှပြင်' },
    { name: 'ကားအပိုပစ္စည်းဆိုင်', icon: '🔧', query: 'ကားအပိုပစ္စည်း' },
    { name: 'အကွဲအဖာဆိုင်', icon: '🔥', query: 'အကွဲအဖာ' },
    { name: 'ဝါယာရိန်း', icon: '⚙️', query: 'ဝါယာရိန်း' }
  ],
  transport: [
    { name: 'ကားဂိတ်', icon: '🚏', query: 'ကားဂိတ်' },
    { name: 'ကုန်စည်ပို့ဆောင်ရေး', icon: '🚛', query: 'ကုန်စည်ပို့ဆောင်' },
    { name: 'ခရီးသွားလာရေးအေဂျင်စီ', icon: '✈️', query: 'ခရီးသွား' },
    { name: 'လေယာဉ်လက်မှတ်', icon: '🎫', query: 'လေယာဉ်လက်မှတ်' },
    { name: 'မီးရထား', icon: '🚆', query: 'မီးရထား' },
    { name: 'ဘူတာ', icon: '🚉', query: 'ဘူတာ' },
    { name: 'လေဆိပ်', icon: '🛫', query: 'လေဆိပ်' },
    { name: 'အမြန်ယာဉ်', icon: '🚐', query: 'အမြန်ယာဉ်' },
    { name: 'တက္ကစီဂိတ်', icon: '🚕', query: 'တက္ကစီ' },
    { name: 'ကူးတို့ဆိပ်', icon: '⛴️', query: 'ကူးတို့' }
  ],
  phone: [
    { name: 'ဖုန်းဆိုင်', icon: '📱', query: 'ဖုန်း' },
    { name: 'ဖုန်းပြုပြင်ရေးဆိုင်', icon: '🔧', query: 'ဖုန်းပြုပြင်' },
    { name: 'ဖုန်းဆက်စပ်ပစ္စည်းဆိုင်', icon: '🎧', query: 'ဖုန်းဆက်စပ်' },
    { name: 'ဆင်းကဒ်ဆိုင်', icon: '📶', query: 'ဆင်းကဒ်' },
    { name: 'တောင်းအပ်ဝန်ဆောင်မှု', icon: '💳', query: 'တောင်းအပ်' }
  ],
  fashion: [
    { name: 'အဝတ်အထည်ဆိုင်', icon: '👕', query: 'အဝတ်အထည်' },
    { name: 'ဖိနပ်ဆိုင်', icon: '👟', query: 'ဖိနပ်' },
    { name: 'အိတ်ဆိုင်', icon: '👜', query: 'အိတ်' },
    { name: 'ရွှေဆိုင်', icon: '💍', query: 'ရွှေ' },
    { name: 'လက်ပတ်နာရီဆိုင်', icon: '⌚', query: 'နာရီ' },
    { name: 'အပ်ချုပ်ဆိုင်', icon: '🧵', query: 'အပ်ချုပ်' },
    { name: 'စက်ချုပ်ဆိုင်', icon: '🪡', query: 'စက်ချုပ်' }
  ],
  tourism: [
    { name: 'ပန်းခြံ', icon: '🌳', query: 'ပန်းခြံ' },
    { name: 'မြစ်ကြည့်ရှုစရာနေရာ', icon: '🌊', query: 'မြစ်' },
    { name: 'အထင်ကရနေရာ', icon: '📍', query: 'အထင်ကရ' },
    { name: 'အင်း/ကန်', icon: '🏞️', query: 'အင်း' },
    { name: 'အထိမ်းအမှတ်နေရာ', icon: '🗿', query: 'အထိမ်းအမှတ်' },
    { name: 'ပြတိုက်', icon: '🏛️', query: 'ပြတိုက်' },
    { name: 'ဓာတ်ပုံရိုက်ရန်နေရာ', icon: '📷', query: 'ဓာတ်ပုံ' }
  ],
  sports: [
    { name: 'ဘီလိယက်ဆိုင်', icon: '🎱', query: 'ဘီလိယက်' },
    { name: 'အားကစားရုံ', icon: '🏋️', query: 'အားကစားရုံ' },
    { name: 'ဘောလုံးကွင်း', icon: '⚽', query: 'ဘောလုံး' },
    { name: 'ဖူဆယ်ကွင်း', icon: '🥅', query: 'ဖူဆယ်' },
    { name: 'ရေကူးကန်', icon: '🏊', query: 'ရေကူး' },
    { name: 'ဂျင်ခန်းမ', icon: '💪', query: 'ဂျင်ခန်းမ' },
    { name: 'အလေးမ', icon: '🏋️', query: 'အလေး' },
    { name: 'ကြက်တောင်ရိုက်ကွင်း', icon: '🏸', query: 'ကြက်တောင်' },
    { name: 'ဘတ်စကတ်ဘောကွင်း', icon: '🏀', query: 'ဘတ်စကတ်ဘော' },
    { name: 'ဘော်လီဘောကွင်း', icon: '🏐', query: 'ဘော်လီဘော' },
    { name: 'စားပွဲတင်တင်းနစ်', icon: '🏓', query: 'တင်းနစ်' }
  ],
  fuel: [
    { name: 'ဓာတ်ဆီဆိုင်', icon: '⛽', query: 'ဓာတ်ဆီ' },
    { name: 'ဒီဇယ်ဆီဆိုင်', icon: '⛽', query: 'ဒီဇယ်' },
    { name: 'အင်ဂျင်ဆီဆိုင်', icon: '🛢️', query: 'အင်ဂျင်ဆီ' },
    { name: 'ဓာတ်ငွေ့ဖြည့်စခန်း', icon: '🔥', query: 'ဓာတ်ငွေ့' },
    { name: 'လျှပ်စစ်ကားအားသွင်းစခန်း', icon: '🔌', query: 'လျှပ်စစ်ကား' }
  ],
  entertainment: [
    { name: 'ကေတီဗွီ', icon: '🎤', query: 'ကေတီဗွီ' },
    { name: 'ဂီတခန်းမ', icon: '🎼', query: 'ဂီတ' },
    { name: 'ပွဲတော်ခန်းမ', icon: '🎪', query: 'ပွဲတော်' },
    { name: 'ဘီယာဆိုင်', icon: '🍺', query: 'ဘီယာ' },
    { name: 'ရုပ်ရှင်ရုံ', icon: '🎬', query: 'ရုပ်ရှင်' },
    { name: 'ဂိမ်းစင်တာ', icon: '🎮', query: 'ဂိမ်း' },
    { name: 'ကာရာအိုကေ', icon: '🎵', query: 'ကာရာအိုကေ' },
    { name: 'ညကလပ်', icon: '🌃', query: 'ညကလပ်' }
  ]
};
  const townships = [
    { id: 'all', name_mm: 'အားလုံး' },
    { id: 'myitkyina', name_mm: 'မြစ်ကြီးနား' },
    { id: 'waingmaw', name_mm: 'ဝိုင်းမော်' },
    { id: 'mohnyin', name_mm: 'မိုးညှင်း' },
    { id: 'mogaung', name_mm: 'မိုးကောင်း' },
    { id: 'hpakant', name_mm: 'ဖားကန့်' },
    { id: 'putao', name_mm: 'ပူတာအို' }
  ];

  const basemaps = [
    { id: 'light', name: '☀️ Light' },
    { id: 'dark', name: '🌙 Dark' },
    { id: 'satellite', name: '🛰️ Satellite' },
    { id: 'osm', name: '🗺️ OSM' }
  ];

  const mapOptions = [
    { id: 'osm', label: '🗺️ OSM Map', icon: '🗺️' },
    { id: 'satellite', label: '🛰️ Satellite', icon: '🛰️' },
    { id: 'dark', label: '🌙 Dark Mode', icon: '🌙' },
    { id: 'wms', label: '📡 WMS Layer', icon: '📡' }
  ];
// Map click location to voice form
useEffect(() => {
  if (!mapClickedLocation) return;
  
  // ✅ Helper function for safe conversion
  const toNumber = (value) => {
    if (typeof value === 'number') return value;
    if (typeof value === 'string') {
      const parsed = parseFloat(value);
      return isNaN(parsed) ? null : parsed;
    }
    return null;
  };
  
  const lat = toNumber(mapClickedLocation.lat);
  const lng = toNumber(mapClickedLocation.lng);
  
  if (lat === null || lng === null) {
    console.warn('⚠️ Invalid coordinates in mapClickedLocation:', mapClickedLocation);
    return;
  }
  
  setVoiceData(prev => ({
    ...prev,
    lat: lat.toFixed(6),
    lng: lng.toFixed(6),
    location_name: prev.location_name || `လတ္: ${lat.toFixed(6)}, လောင်း: ${lng.toFixed(6)}`
  }));
}, [mapClickedLocation]);

  const currentSubcategories = subcategories[selectedCategory] || [];

  // ✅ GPS Toggle
  const toggleGPS = () => {
    if (onToggleGPS) {
      onToggleGPS();
    } else {
      if (!isGPSOn) {
        onGetUserLocation();
      }
    }
  };

  // ✅ Map Selector Change
  const handleMapChange = (mapId) => {
    setSelectedMap(mapId);
    setShowMapSelector(false);
    if (onBasemapChange) {
      onBasemapChange(mapId);
    }
    if (setBasemap) {
      setBasemap(mapId);
    }
  };

  // ✅ Basemap Change Handler (Dropdown) - setBasemap ကိုသုံးပါ
  const handleBasemapChange = (e) => {
    const value = e.target.value;
    if (setBasemap) {
      setBasemap(value);
    }
    if (onBasemapChange) {
      onBasemapChange(value);
    }
  };

  // Handle Category Click
  const handleCategoryClick = (catId) => {
    setSelectedCategory(catId);
    setSelectedSubcategory(null);
  };

  // Handle Subcategory Click
  const handleSubcategoryClick = (sub) => {
    setSelectedSubcategory(sub);
    if (sub) {
      const filtered = locations.filter(loc => 
        loc.category === selectedCategory &&
        (loc.subcategory || '').toLowerCase().includes(sub.name.toLowerCase()) ||
        (loc.name_mm || '').toLowerCase().includes(sub.name.toLowerCase())
      );
      setFilteredLocations(filtered);
    } else {
      setFilteredLocations(locations.filter(loc => loc.category === selectedCategory));
    }
  };

  // Handle Login
  const handleLogin = (e) => {
    e.preventDefault();
    if (username === 'admin' && password === 'admin123') {
      setIsLoggedIn(true);
      setShowLogin(false);
      alert('✅ အကောင့်ဝင်ရောက်မှု အောင်မြင်ပါသည်။');
    } else {
      alert('❌ အသုံးပြုသူအမည် သို့မဟုတ် စကားဝှက် မှားယွင်းနေပါသည်။');
    }
  };

// Sidebar.js - handleVoiceSubmit

const handleVoiceSubmit = async (e) => {
    e.preventDefault();
    
    // ✅ လိုအပ်တဲ့အချက်တွေကိုပဲစစ်ပါ
    if (!voiceData.description) {
        alert('ကျေးဇူးပြု၍ အကြောင်းအရာထည့်ပါ');
        return;
    }
    
    if (!voiceData.lat || !voiceData.lng) {
        alert('ကျေးဇူးပြု၍ မြေပုံပေါ်တွင် တည်နေရာကိုရွေးပါ');
        return;
    }
    
    try {
        const response = await fetch('/api/reports', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                report_type: voiceData.report_type,
                description: voiceData.description,
                location_name: voiceData.location_name || '',
                lat: parseFloat(voiceData.lat),
                lng: parseFloat(voiceData.lng),
                phone: voiceData.phone || '',           // ✅ မထည့်ရင်လည်းရတယ်
                email: voiceData.email || '',           // ✅ မထည့်ရင်လည်းရတယ်
                reporter_name: voiceData.reporter_name || ''  // ✅ မထည့်ရင်လည်းရတယ်
            })
        });
        
        const data = await response.json();
        
        if (data.success) {
            alert('✅ ပြည်သူ့အသံ အောင်မြင်စွာ တင်ပြပြီးပါပြီ။');
            setShowVoiceForm(false);
            setVoiceData({
                report_type: 'road',
                description: '',
                location_name: '',
                lat: '',
                lng: '',
                photo: null,
                phone: '',
                email: '',
                reporter_name: ''
            });
        } else {
            alert('❌ တင်ပြရာတွင် အမှားရှိပါသည်။');
        }
    } catch (error) {
        console.error('Error submitting report:', error);
        alert('❌ ဆာဗာနှင့် ချိတ်ဆက်ရာတွင် အမှားရှိပါသည်။');
    }
};
// Handle Report Submit
const handleReportSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!reportData.title) {
        alert('ကျေးဇူးပြု၍ ခေါင်းစဉ်ထည့်ပါ');
        return;
    }
    
    if (!reportData.description) {
        alert('ကျေးဇူးပြု၍ အကြောင်းအရာထည့်ပါ');
        return;
    }
    
    try {
        // TODO: API call to submit report
        // const response = await fetch('/api/reports', {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify(reportData)
        // });
        
        alert('📝 အစီရင်ခံစာ တင်ပြမှု အောင်မြင်ပါသည်။');
        setShowReportForm(false);
        setReportData({
            title: '',
            description: '',
            location_name: '',
            lat: '',
            lng: '',
            severity: 'medium',
            reporter_name: '',
            reporter_phone: '',
            photos: []
        });
    } catch (error) {
        console.error('Error submitting report:', error);
        alert('❌ တင်ပြရာတွင် အမှားရှိပါသည်။');
    }
};
  // Handle Register Submit
  const handleRegisterSubmit = (e) => {
    e.preventDefault();
    alert('🏪 လုပ်ငန်းအသစ် စာရင်းသွင်းမှု အောင်မြင်ပါသည်။');
    setShowRegisterForm(false);
    setRegName('');
    setRegPhone('');
    setRegTown('myitkyina');
    setRegCat('');
    setRegSubCat('');
  };

  // Filter locations when category changes
  useEffect(() => {
    if (selectedCategory === 'all') {
      setFilteredLocations(locations);
    } else {
      setFilteredLocations(locations.filter(loc => loc.category === selectedCategory));
    }
  }, [selectedCategory, locations, setFilteredLocations]);

  return (
    <div className="sidebar" style={{
      width: '100%',
      height: '100%',
      background: '#0f172a',
      color: 'white',
      padding: '16px',
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* Logo */}
      <div style={{ marginBottom: '16px', textAlign: 'center' }}>
        <h2 style={{ fontSize: '1.2rem', margin: 0, color: '#3b82f6' }}>🏠 MKA SMART MAP</h2>
        <p style={{ fontSize: '0.6rem', color: '#94a3b8', margin: '4px 0 0 0' }}>v2.0 - မြစ်ကြီးနား</p>
      </div>

      {/* ✅ Top Action Buttons */}
      <div style={{ 
        display: 'flex', 
        gap: '6px', 
        marginBottom: '12px',
        flexWrap: 'wrap'
      }}>
        <button
          onClick={toggleGPS}
          style={{
            flex: 1,
            padding: '6px 10px',
            background: isGPSOn ? '#22c55e' : '#3b82f6',
            border: 'none',
            borderRadius: '6px',
            color: 'white',
            cursor: 'pointer',
            fontSize: '0.65rem',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px'
          }}
        >
          {isGPSOn ? '📍 GPS ON' : '📍 GPS OFF'}
        </button>
        <button
          onClick={onShowDashboard}
          style={{
            flex: 1,
            padding: '6px 10px',
            background: '#8b5cf6',
            border: 'none',
            borderRadius: '6px',
            color: 'white',
            cursor: 'pointer',
            fontSize: '0.65rem',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px'
          }}
        >
          📊 Dashboard
        </button>
        <button
          onClick={() => setShowAIChat(!showAIChat)}
          style={{
            flex: 1,
            padding: '6px 10px',
            background: showAIChat ? '#f59e0b' : '#6366f1',
            border: 'none',
            borderRadius: '6px',
            color: 'white',
            cursor: 'pointer',
            fontSize: '0.65rem',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px'
          }}
        >
          {showAIChat ? '🤖 AI ON' : '🤖 AI OFF'}
        </button>
        <button
          onClick={onShowNotifications}
          style={{
            flex: 1,
            padding: '6px 10px',
            background: showNotifications ? '#22c55e' : '#ef4444',
            border: 'none',
            borderRadius: '6px',
            color: 'white',
            cursor: 'pointer',
            fontSize: '0.65rem',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px'
          }}
        >
          {showNotifications ? '🔔 ON' : '🔔 OFF'}
        </button>
      </div>

      {/* Emergency Button */}
      <button 
        onClick={onEmergencyClick}
        style={{
          width: '100%',
          padding: '10px 16px',
          background: '#dc2626',
          border: 'none',
          borderRadius: '8px',
          color: 'white',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: '600',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          marginBottom: '12px'
        }}
      >
        🚨 အရေးပေါ်ဌာနများ
      </button>

      {/* Map Selector Button */}
      <div style={{ marginBottom: '8px' }}>
        <button
          onClick={() => setShowMapSelector(!showMapSelector)}
          style={{
            width: '100%',
            padding: '8px',
            background: showMapSelector ? '#3b82f6' : '#1e293b',
            border: '1px solid #334155',
            borderRadius: '6px',
            color: 'white',
            cursor: 'pointer',
            fontSize: '0.7rem',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
        >
          🗺️ မြေပုံရွေးရန် {showMapSelector ? '▲' : '▼'}
        </button>
        
        {showMapSelector && (
          <div style={{
            marginTop: '4px',
            background: '#1e293b',
            borderRadius: '6px',
            border: '1px solid #334155',
            overflow: 'hidden'
          }}>
            {mapOptions.map(option => (
              <div
                key={option.id}
                onClick={() => handleMapChange(option.id)}
                style={{
                  padding: '8px 12px',
                  cursor: 'pointer',
                  background: selectedMap === option.id ? '#3b82f6' : 'transparent',
                  borderBottom: '1px solid #334155',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  fontSize: '0.75rem',
                  transition: 'background 0.2s'
                }}
                onMouseEnter={(e) => {
                  if (selectedMap !== option.id) {
                    e.currentTarget.style.background = '#334155';
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedMap !== option.id) {
                    e.currentTarget.style.background = 'transparent';
                  }
                }}
              >
                <span>{option.icon}</span>
                <span>{option.label}</span>
                {selectedMap === option.id && (
                  <span style={{ marginLeft: 'auto', color: '#22c55e' }}>✅</span>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* ✅ Basemap Switch - setBasemap ကိုသုံးပါ */}
      <div style={{ marginBottom: '12px' }}>
        <select
          value={basemap}
          onChange={handleBasemapChange}
          style={{
            width: '100%',
            padding: '6px 10px',
            background: '#1e293b',
            border: '1px solid #334155',
            borderRadius: '6px',
            color: 'white',
            fontSize: '0.7rem',
            cursor: 'pointer'
          }}
        >
          {basemaps.map(bm => (
            <option key={bm.id} value={bm.id}>
              {bm.name}
            </option>
          ))}
        </select>
      </div>

      <hr style={{ borderColor: '#334155', marginBottom: '12px' }} />

      {/* Stats */}
      <div style={{ display: 'flex', gap: '6px', marginBottom: '12px', flexWrap: 'wrap' }}>
        <div style={{ background: '#1e293b', padding: '4px 10px', borderRadius: '4px', fontSize: '0.6rem' }}>
          📍 {locations.length}
        </div>
        <div style={{ background: '#1e293b', padding: '4px 10px', borderRadius: '4px', fontSize: '0.6rem' }}>
          🏷️ 19
        </div>
        <div style={{ background: '#1e293b', padding: '4px 10px', borderRadius: '4px', fontSize: '0.6rem' }}>
          📂 134
        </div>
        {isLoading && <div style={{ color: '#f59e0b', fontSize: '0.6rem' }}>⏳ Loading...</div>}
      </div>

      <hr style={{ borderColor: '#334155', marginBottom: '12px' }} />

      {/* Township Dropdown */}
      <div style={{ marginBottom: '12px' }}>
        <h3 style={{ fontSize: '0.75rem', marginBottom: '6px' }}>🏘️ မြို့နယ်</h3>
        <select
          value={selectedTownship}
          onChange={(e) => setSelectedTownship(e.target.value)}
          style={{
            width: '100%',
            padding: '8px',
            background: '#1e293b',
            border: '1px solid #334155',
            borderRadius: '6px',
            color: 'white',
            fontSize: '0.8rem',
            cursor: 'pointer'
          }}
        >
          {townships.map(t => (
            <option key={t.id} value={t.id}>{t.name_mm}</option>
          ))}
        </select>
      </div>

      <hr style={{ borderColor: '#334155', marginBottom: '12px' }} />

      {/* Category Dropdown */}
      <div style={{ marginBottom: '12px' }}>
        <h3 style={{ fontSize: '0.75rem', marginBottom: '6px' }}>📂 အဓိကလုပ်ငန်းအမျိုးအစား (19)</h3>
        <select
          value={selectedCategory}
          onChange={(e) => handleCategoryClick(e.target.value)}
          style={{
            width: '100%',
            padding: '8px',
            background: '#1e293b',
            border: '1px solid #334155',
            borderRadius: '6px',
            color: 'white',
            fontSize: '0.8rem',
            cursor: 'pointer'
          }}
        >
          {categories.map(cat => (
            <option key={cat.id} value={cat.id}>
              {cat.icon} {cat.name_mm}
            </option>
          ))}
        </select>

        {selectedCategory !== 'all' && currentSubcategories.length > 0 && (
          <div style={{ marginTop: '8px' }}>
            <h4 style={{ fontSize: '0.7rem', marginBottom: '6px', color: '#94a3b8' }}>
              📂 လုပ်ငန်းခွဲအသေးစိတ် ({currentSubcategories.length} ခု)
            </h4>
            <select
              value={selectedSubcategory ? selectedSubcategory.name : ''}
              onChange={(e) => {
                const selected = currentSubcategories.find(s => s.name === e.target.value);
                if (selected) {
                  handleSubcategoryClick(selected);
                } else {
                  handleSubcategoryClick(null);
                }
              }}
              style={{
                width: '100%',
                padding: '8px',
                background: '#1e293b',
                border: '1px solid #334155',
                borderRadius: '6px',
                color: 'white',
                fontSize: '0.75rem',
                cursor: 'pointer'
              }}
            >
              <option value="">အားလုံး</option>
              {currentSubcategories.map((sub, idx) => (
                <option key={idx} value={sub.name}>
                  {sub.icon} {sub.name}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>

      <hr style={{ borderColor: '#334155', marginBottom: '12px' }} />

      {/* Water Level Slider */}
      <div style={{ marginBottom: '12px' }}>
        <h3 style={{ fontSize: '0.75rem', marginBottom: '6px' }}>🌊 ရေမှတ် (cm)</h3>
        <input
          type="range"
          min="0"
          max="1500"
          value={waterLevel}
          onChange={(e) => setWaterLevel(parseInt(e.target.value))}
          style={{
            width: '100%',
            margin: '6px 0',
            accentColor: waterLevel > 1200 ? '#dc3545' : waterLevel > 800 ? '#f59e0b' : '#3b82f6'
          }}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.65rem' }}>
          <span>လက်ရှိ: <strong style={{ 
            color: waterLevel > 1200 ? '#dc3545' : waterLevel > 800 ? '#f59e0b' : 'white'
          }}>{waterLevel}</strong> cm</span>
          <span style={{ 
            color: waterLevel > 1200 ? '#dc3545' : waterLevel > 800 ? '#f59e0b' : '#94a3b8'
          }}>
            {waterLevel > 1200 ? '🔴 အရေးပေါ်' : waterLevel > 800 ? '🟡 သတိပေး' : '🟢 ပုံမှန်'}
          </span>
        </div>
      </div>

      <hr style={{ borderColor: '#334155', marginBottom: '12px' }} />

      {/* Login Form */}
      <div style={{ marginBottom: '12px' }}>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap', marginBottom: '8px' }}>
          {isLoggedIn ? (
            <span style={{ fontSize: '0.7rem', color: '#22c55e' }}>✅ {username}</span>
          ) : (
            <button 
              onClick={() => setShowLogin(!showLogin)}
              style={{
                padding: '4px 12px',
                background: '#3b82f6',
                border: 'none',
                borderRadius: '6px',
                color: 'white',
                cursor: 'pointer',
                fontSize: '0.7rem'
              }}
            >
              🔐 အကောင့်ဝင်ရန်
            </button>
          )}
          <button 
            onClick={() => { setIsLoggedIn(false); setShowLogin(false); }}
            style={{
              padding: '4px 12px',
              background: '#ef4444',
              border: 'none',
              borderRadius: '6px',
              color: 'white',
              cursor: 'pointer',
              fontSize: '0.7rem'
            }}
          >
            🚪 ထွက်ရန်
          </button>
        </div>

        {showLogin && !isLoggedIn && (
          <div style={{
            background: '#1e293b',
            padding: '15px',
            borderRadius: '8px',
            marginBottom: '8px'
          }}>
            <h4 style={{ fontSize: '0.8rem', marginBottom: '10px' }}>🔐 အကောင့်ဝင်ရန်</h4>
            <form onSubmit={handleLogin}>
              <input
                type="text"
                placeholder="အသုံးပြုသူအမည်"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                style={{
                  width: '100%',
                  padding: '8px',
                  marginBottom: '8px',
                  background: '#0f172a',
                  border: '1px solid #334155',
                  borderRadius: '6px',
                  color: 'white',
                  fontSize: '0.8rem'
                }}
              />
              <input
                type="password"
                placeholder="စကားဝှက်"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{
                  width: '100%',
                  padding: '8px',
                  marginBottom: '8px',
                  background: '#0f172a',
                  border: '1px solid #334155',
                  borderRadius: '6px',
                  color: 'white',
                  fontSize: '0.8rem'
                }}
              />
              <button
                type="submit"
                style={{
                  width: '100%',
                  padding: '8px',
                  background: '#3b82f6',
                  border: 'none',
                  borderRadius: '6px',
                  color: 'white',
                  cursor: 'pointer',
                  fontWeight: 'bold'
                }}
              >
                အကောင့်ဝင်ရန်
              </button>
              <div style={{ fontSize: '0.6rem', color: '#94a3b8', marginTop: '8px' }}>
                Username: admin | Password: admin123
              </div>
            </form>
          </div>
        )}
      </div>
      
           <hr style={{ borderColor: '#334155', marginBottom: '12px' }} />

      {/* Voice Report Form Button */}
      <div style={{ marginBottom: '12px' }}>
        <button
          onClick={() => setShowVoiceForm(!showVoiceForm)}
          style={{
            width: '100%',
            padding: '8px',
            background: '#8b5cf6',
            border: 'none',
            borderRadius: '6px',
            color: 'white',
            cursor: 'pointer',
            fontWeight: 'bold',
            fontSize: '0.8rem'
          }}
        >
          🗣️ ပြည်သူ့အသံ တင်ပြရန်
        </button>
      </div>
      {/* ✅ Admin Button */}
<div style={{ marginBottom: '12px' }}>
    <button
        onClick={onToggleAdmin}
   style={{
      width: '100%',
      padding: '8px',
      background: '#8b5cf6',
      border: 'none',
      borderRadius: '6px',
      color: 'white',
      cursor: 'pointer',
      fontWeight: 'bold',
      fontSize: '0.8rem',
      marginTop: '8px'
    }}
    >
        📊 Admin Dashboard
    </button>
</div>

{/* Voice Report Form */}
{showVoiceForm && (
    <div style={{
        background: '#1e293b',
        padding: '15px',
        borderRadius: '8px',
        marginBottom: '12px',
        borderLeft: '3px solid #8b5cf6'
    }}>
        <h4 style={{ fontSize: '0.8rem', marginBottom: '10px', color: '#8b5cf6', display: 'flex', alignItems: 'center', gap: '8px' }}>
            🗣️ ပြည်သူ့အသံ တင်ပြရန်
            <span style={{ fontSize: '0.55rem', color: '#94a3b8' }}>(မြေပုံပေါ်တွင် ကလစ်ထောက်ပြီး တည်နေရာရွေးပါ)</span>
        </h4>
        
        <form onSubmit={handleVoiceSubmit}>
            {/* Report Type */}
            <select
                value={voiceData.report_type}
                onChange={(e) => setVoiceData({...voiceData, report_type: e.target.value})}
                style={{
                    width: '100%',
                    padding: '8px',
                    marginBottom: '8px',
                    background: '#0f172a',
                    border: '1px solid #334155',
                    borderRadius: '6px',
                    color: 'white',
                    fontSize: '0.8rem',
                    cursor: 'pointer'
                }}
            >
                <option value="road">🚧 လမ်းတံတားပျက်စီးမှု</option>
                <option value="trash">🗑️ အမှိုက်ပုံပြဿနာ</option>
                <option value="electric">💡 မီးလင်းရေးလိုအပ်ချက်</option>
                <option value="water">💧 ရေပေးဝေရေးပြဿနာ</option>
                <option value="drainage">🚿 ရေနုတ်မြောင်းပိတ်ဆို့ခြင်း</option>
                <option value="noise">🔊 ဆူညံသံညစ်ညမ်းမှု</option>
                <option value="fire">🔥 မီးလောင်မှု</option>
                <option value="other">📝 အခြား</option>
            </select>
            
            {/* Description */}
            <textarea
                placeholder="အကြောင်းအရာ အသေးစိတ် *"
                rows="3"
                value={voiceData.description}
                onChange={(e) => setVoiceData({...voiceData, description: e.target.value})}
                style={{
                    width: '100%',
                    padding: '8px',
                    marginBottom: '8px',
                    background: '#0f172a',
                    border: '1px solid #334155',
                    borderRadius: '6px',
                    color: 'white',
                    fontSize: '0.8rem',
                    resize: 'vertical'
                }}
                required
            />
            
            {/* Location Name */}
            <input
                type="text"
                placeholder="📍 တည်နေရာအမည် (ဥပမာ - ရွှေပြည်သာရပ်ကွက်)"
                value={voiceData.location_name}
                onChange={(e) => setVoiceData({...voiceData, location_name: e.target.value})}
                style={{
                    width: '100%',
                    padding: '8px',
                    marginBottom: '8px',
                    background: '#0f172a',
                    border: '1px solid #334155',
                    borderRadius: '6px',
                    color: 'white',
                    fontSize: '0.8rem'
                }}
            />
            
            {/* Coordinates */}
            <div style={{ display: 'flex', gap: '8px' }}>
                <input
                    type="text"
                    placeholder="လတ္တီတွဒ်"
                    value={voiceData.lat}
                    onChange={(e) => setVoiceData({...voiceData, lat: e.target.value})}
                    style={{
                        flex: 1,
                        padding: '8px',
                        marginBottom: '8px',
                        background: '#0f172a',
                        border: '1px solid #334155',
                        borderRadius: '6px',
                        color: '#94a3b8',
                        fontSize: '0.75rem'
                    }}
                    readOnly
                />
                <input
                    type="text"
                    placeholder="လောင်ဂျီတွဒ်"
                    value={voiceData.lng}
                    onChange={(e) => setVoiceData({...voiceData, lng: e.target.value})}
                    style={{
                        flex: 1,
                        padding: '8px',
                        marginBottom: '8px',
                        background: '#0f172a',
                        border: '1px solid #334155',
                        borderRadius: '6px',
                        color: '#94a3b8',
                        fontSize: '0.75rem'
                    }}
                    readOnly
                />
            </div>
            
            {/* ✅ Phone - ထည့်ရန်မလိုအပ်ဘူး (ဒါပေမယ့်ထည့်ရင်ရတယ်) */}
            <input
                type="tel"
                placeholder="📞 ဆက်သွယ်ရန်ဖုန်းနံပါတ် (မထည့်လည်းရပါတယ်)"
                value={voiceData.phone}
                onChange={(e) => setVoiceData({...voiceData, phone: e.target.value})}
                style={{
                    width: '100%',
                    padding: '8px',
                    marginBottom: '8px',
                    background: '#0f172a',
                    border: '1px solid #334155',
                    borderRadius: '6px',
                    color: 'white',
                    fontSize: '0.8rem'
                }}
            />
            
            {/* ✅ Email - မထည့်လည်းရပါတယ် (ထည့်ရင်လည်းရတယ်) */}
            <input
                type="email"
                placeholder="✉️ အီးမေးလ်လိပ်စာ (မထည့်လည်းရပါတယ်)"
                value={voiceData.email}
                onChange={(e) => setVoiceData({...voiceData, email: e.target.value})}
                style={{
                    width: '100%',
                    padding: '8px',
                    marginBottom: '8px',
                    background: '#0f172a',
                    border: '1px solid #334155',
                    borderRadius: '6px',
                    color: 'white',
                    fontSize: '0.8rem'
                }}
            />
            
            {/* Reporter Name - မထည့်လည်းရပါတယ် */}
            <input
                type="text"
                placeholder="👤 အစီရင်ခံသူအမည် (မထည့်လည်းရပါတယ်)"
                value={voiceData.reporter_name}
                onChange={(e) => setVoiceData({...voiceData, reporter_name: e.target.value})}
                style={{
                    width: '100%',
                    padding: '8px',
                    marginBottom: '8px',
                    background: '#0f172a',
                    border: '1px solid #334155',
                    borderRadius: '6px',
                    color: 'white',
                    fontSize: '0.8rem'
                }}
            />
            
            {/* Photo */}
            <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                    if (e.target.files.length > 0) {
                        setVoiceData({...voiceData, photo: e.target.files[0]});
                    }
                }}
                style={{
                    width: '100%',
                    padding: '6px',
                    marginBottom: '8px',
                    background: '#0f172a',
                    border: '1px solid #334155',
                    borderRadius: '6px',
                    color: 'white',
                    fontSize: '0.7rem'
                }}
            />
            
            <button
                type="submit"
                style={{
                    width: '100%',
                    padding: '8px',
                    background: '#8b5cf6',
                    border: 'none',
                    borderRadius: '6px',
                    color: 'white',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    fontSize: '0.8rem'
                }}
            >
                🗣️ ပြည်သူ့အသံ တင်ပြမည်
            </button>
        </form>
    </div>
)}

      <hr style={{ borderColor: '#334155', marginBottom: '12px' }} />

      {/* Report Form Button */}
      <div style={{ marginBottom: '12px' }}>
        <button
          onClick={() => setShowReportForm(!showReportForm)}
          style={{
            width: '100%',
            padding: '8px',
            background: '#ef4444',
            border: 'none',
            borderRadius: '6px',
            color: 'white',
            cursor: 'pointer',
            fontWeight: 'bold',
            fontSize: '0.8rem'
          }}
        >
          🌊 ရေဘေးအစီရင်ခံရန်
        </button>
      </div>

      {/* Report Form */}
      {showReportForm && (
        <div style={{
          background: '#1e293b',
          padding: '15px',
          borderRadius: '8px',
          marginBottom: '12px'
        }}>
          <h4 style={{ fontSize: '0.8rem', marginBottom: '10px', color: '#ef4444' }}>📝 အစီရင်ခံစာ</h4>
          <form onSubmit={handleReportSubmit}>
            <input
              type="text"
              placeholder="ခေါင်းစဉ် *"
              value={reportData.title}
              onChange={(e) => setReportData({...reportData, title: e.target.value})}
              style={{
                width: '100%',
                padding: '8px',
                marginBottom: '8px',
                background: '#0f172a',
                border: '1px solid #334155',
                borderRadius: '6px',
                color: 'white',
                fontSize: '0.8rem'
              }}
              required
            />
            <textarea
              placeholder="အကြောင်းအရာ *"
              rows="3"
              value={reportData.description}
              onChange={(e) => setReportData({...reportData, description: e.target.value})}
              style={{
                width: '100%',
                padding: '8px',
                marginBottom: '8px',
                background: '#0f172a',
                border: '1px solid #334155',
                borderRadius: '6px',
                color: 'white',
                fontSize: '0.8rem'
              }}
              required
            />
            <input
              type="text"
              placeholder="တည်နေရာ"
              value={reportData.location_name}
              onChange={(e) => setReportData({...reportData, location_name: e.target.value})}
              style={{
                width: '100%',
                padding: '8px',
                marginBottom: '8px',
                background: '#0f172a',
                border: '1px solid #334155',
                borderRadius: '6px',
                color: 'white',
                fontSize: '0.8rem'
              }}
            />
            <div style={{ display: 'flex', gap: '8px' }}>
              <input
                type="text"
                placeholder="လတ္တီတွဒ်"
                value={reportData.lat}
                onChange={(e) => setReportData({...reportData, lat: e.target.value})}
                style={{
                  flex: 1,
                  padding: '8px',
                  marginBottom: '8px',
                  background: '#0f172a',
                  border: '1px solid #334155',
                  borderRadius: '6px',
                  color: 'white',
                  fontSize: '0.8rem'
                }}
              />
              <input
                type="text"
                placeholder="လောင်ဂျီတွဒ်"
                value={reportData.lng}
                onChange={(e) => setReportData({...reportData, lng: e.target.value})}
                style={{
                  flex: 1,
                  padding: '8px',
                  marginBottom: '8px',
                  background: '#0f172a',
                  border: '1px solid #334155',
                  borderRadius: '6px',
                  color: 'white',
                  fontSize: '0.8rem'
                }}
              />
            </div>
            <select
              value={reportData.severity}
              onChange={(e) => setReportData({...reportData, severity: e.target.value})}
              style={{
                width: '100%',
                padding: '8px',
                marginBottom: '8px',
                background: '#0f172a',
                border: '1px solid #334155',
                borderRadius: '6px',
                color: 'white',
                fontSize: '0.8rem'
              }}
            >
              <option value="low">🟢 အနည်းငယ်</option>
              <option value="medium">🟡 အလယ်အလတ်</option>
              <option value="high">🟠 ပြင်းထန်</option>
              <option value="critical">🔴 အရေးပေါ်</option>
            </select>
            <input
              type="text"
              placeholder="အစီရင်ခံသူအမည်"
              value={reportData.reporter_name}
              onChange={(e) => setReportData({...reportData, reporter_name: e.target.value})}
              style={{
                width: '100%',
                padding: '8px',
                marginBottom: '8px',
                background: '#0f172a',
                border: '1px solid #334155',
                borderRadius: '6px',
                color: 'white',
                fontSize: '0.8rem'
              }}
            />
            <input
              type="tel"
              placeholder="ဖုန်းနံပါတ်"
              value={reportData.reporter_phone}
              onChange={(e) => setReportData({...reportData, reporter_phone: e.target.value})}
              style={{
                width: '100%',
                padding: '8px',
                marginBottom: '8px',
                background: '#0f172a',
                border: '1px solid #334155',
                borderRadius: '6px',
                color: 'white',
                fontSize: '0.8rem'
              }}
            />
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={(e) => setReportData({...reportData, photos: Array.from(e.target.files)})}
              style={{
                width: '100%',
                padding: '8px',
                marginBottom: '8px',
                background: '#0f172a',
                border: '1px solid #334155',
                borderRadius: '6px',
                color: 'white',
                fontSize: '0.8rem'
              }}
            />
            <button
              type="submit"
              style={{
                width: '100%',
                padding: '8px',
                background: '#ef4444',
                border: 'none',
                borderRadius: '6px',
                color: 'white',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              📢 တင်ပြမည်
            </button>
          </form>
        </div>
      )}

      <hr style={{ borderColor: '#334155', marginBottom: '12px' }} />

      {/* Register New Business Button */}
      <div style={{ marginBottom: '12px' }}>
        <button
          onClick={() => setShowRegisterForm(!showRegisterForm)}
          style={{
            width: '100%',
            padding: '8px',
            background: '#22c55e',
            border: 'none',
            borderRadius: '6px',
            color: 'white',
            cursor: 'pointer',
            fontWeight: 'bold',
            fontSize: '0.8rem'
          }}
        >
          🏪 လုပ်ငန်းအသစ် စာရင်းသွင်းရန်
        </button>
      </div>

      {/* Register New Business Form */}
      {showRegisterForm && (
        <div style={{
          background: '#1e293b',
          padding: '15px',
          borderRadius: '8px',
          marginBottom: '12px'
        }}>
          <h4 style={{ fontSize: '0.8rem', marginBottom: '10px', color: '#22c55e' }}>🏪 လုပ်ငန်းအသစ် စာရင်းသွင်းရန်</h4>
          <form onSubmit={handleRegisterSubmit}>
            <input
              type="text"
              placeholder="လုပ်ငန်းအမည် *"
              value={regName}
              onChange={(e) => setRegName(e.target.value)}
              style={{
                width: '100%',
                padding: '8px',
                marginBottom: '8px',
                background: '#0f172a',
                border: '1px solid #334155',
                borderRadius: '6px',
                color: 'white',
                fontSize: '0.8rem'
              }}
              required
            />
            <input
              type="text"
              placeholder="ဖုန်းနံပါတ်"
              value={regPhone}
              onChange={(e) => setRegPhone(e.target.value)}
              style={{
                width: '100%',
                padding: '8px',
                marginBottom: '8px',
                background: '#0f172a',
                border: '1px solid #334155',
                borderRadius: '6px',
                color: 'white',
                fontSize: '0.8rem'
              }}
            />
            <select
              value={regTown}
              onChange={(e) => setRegTown(e.target.value)}
              style={{
                width: '100%',
                padding: '8px',
                marginBottom: '8px',
                background: '#0f172a',
                border: '1px solid #334155',
                borderRadius: '6px',
                color: 'white',
                fontSize: '0.8rem'
              }}
            >
              <option value="myitkyina">မြစ်ကြီးနား</option>
              <option value="waingmaw">ဝိုင်းမော်</option>
              <option value="mohnyin">မိုးညှင်း</option>
              <option value="mogaung">မိုးကောင်း</option>
              <option value="hpakant">ဖားကန့်</option>
              <option value="putao">ပူတာအို</option>
            </select>
            <select
              value={regCat}
              onChange={(e) => {
                setRegCat(e.target.value);
                setRegSubCat('');
              }}
              style={{
                width: '100%',
                padding: '8px',
                marginBottom: '8px',
                background: '#0f172a',
                border: '1px solid #334155',
                borderRadius: '6px',
                color: 'white',
                fontSize: '0.8rem'
              }}
              required
            >
              <option value="">အဓိကလုပ်ငန်းအမျိုးအစား ရွေးပါ</option>
              {categories.filter(c => c.id !== 'all').map(cat => (
                <option key={cat.id} value={cat.id}>
                  {cat.icon} {cat.name_mm}
                </option>
              ))}
            </select>
            <select
              value={regSubCat}
              onChange={(e) => setRegSubCat(e.target.value)}
              style={{
                width: '100%',
                padding: '8px',
                marginBottom: '8px',
                background: '#0f172a',
                border: '1px solid #334155',
                borderRadius: '6px',
                color: 'white',
                fontSize: '0.8rem'
              }}
              required
            >
              <option value="">လုပ်ငန်းခွဲ ရွေးပါ</option>
              {regCat && subcategories[regCat]?.map((sub, idx) => (
                <option key={idx} value={sub.name}>
                  {sub.icon} {sub.name}
                </option>
              ))}
            </select>
            <button
              type="submit"
              style={{
                width: '100%',
                padding: '8px',
                background: '#22c55e',
                border: 'none',
                borderRadius: '6px',
                color: 'white',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              📝 စာရင်းတင်သွင်းမည်
            </button>
          </form>
        </div>
      )}

      <hr style={{ borderColor: '#334155', marginBottom: '12px' }} />

      {/* Summary Footer */}
      <div style={{ 
        marginTop: '8px', 
        padding: '8px', 
        background: '#1e293b', 
        borderRadius: '6px',
        textAlign: 'center'
      }}>
        <div style={{ fontSize: '0.65rem', color: '#94a3b8' }}>
          📍 စုစုပေါင်း: {locations.length} ခု
          {selectedCategory !== 'all' && ` | ${categories.find(c => c.id === selectedCategory)?.name_mm || selectedCategory}`}
          {selectedSubcategory && ` | ${selectedSubcategory.name}`}
        </div>
        <div style={{ fontSize: '0.55rem', color: '#64748b', marginTop: '4px' }}>
          {selectedSubcategory && `🔍 ${selectedSubcategory.name} (${locations.filter(l => l.category === selectedCategory).filter(l => (l.subcategory || '').toLowerCase().includes(selectedSubcategory.query.toLowerCase()) || (l.name_mm || '').toLowerCase().includes(selectedSubcategory.query.toLowerCase())).length} ခု)`}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;